import { defineEffect } from '../../../core/effect';

/**
 * **効果の無効**（Issue #538）。カードの効果が無効にされた瞬間。
 *
 * 開く: `chain_disabled`。赤い輪が落ちて「NEGATED」。
 * **カードが場に居なければ画面の中央に**（手札から発動して無効にされた場合）。
 */
const COLOR = '#ff2e3c';

export default defineEffect({
  situation: 'chain_disabled',
  label: '効果の無効',
  color: COLOR,
  sounds: () => [{ at: 0, name: 'revoked' }],

  /**
   * **このイベントは `{ chain: n }` だけ**（どのカードかを持っていない）。
   * **そのチェーンを組んだ `chaining` から引く**（窓はターン。同じチェーンの番号で突き合わせる）。
   */
  opens({ payload, history }) {
    const from = history.last('chaining', { within: 'turn', filter: (p) => p.chain === payload.chain });
    const card = from?.payload ?? {};
    return { ...payload, uid: card.uid ?? null, code: card.code ?? null, zone: card.zone ?? null, player: card.player ?? 0 };
  },

  layers: [
    {
      id: 'mark',
      label: '禁止の印',
      part: 'ring',
      at: { card: '{uid}', else: { screen: [960, 540] } },
      props: { color: COLOR, width: 14, ticks: 2, tickLen: 0.42 },
      tf: {
        scale: { keys: [{ ms: 0, value: 2.4 }, { ms: 240, value: 1.1, ease: 'ease_out' }, { ms: 760, value: 1.1 }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 120, value: 1 }, { ms: 640, value: 1 }, { ms: 820, value: 0 }] },
        rotation: { keys: [{ ms: 0, value: -40 }, { ms: 240, value: 0, ease: 'ease_out' }] },
      },
    },
    {
      id: 'label',
      label: 'NEGATED',
      part: 'text',
      parent: 'mark',
      props: { text: 'DISABLED', size: 72, color: COLOR },
      tf: {
        y: 170,
        opacity: { keys: [{ ms: 180, value: 0 }, { ms: 320, value: 1 }, { ms: 700, value: 0 }] },
      },
    },
  ],
}, 'chain_disabled_effect.js');
